<template>
  <section>
    <LoadingSpinner v-if="loading" />
    <div v-if="!loading" class="col-md-12">
      <h2 v-if="!simplify && false">Step 3 / 3</h2>
      <h3 class="card-title text-primary mb-4" v-if="!simplify">
        <span v-if="addOrder">
          {{ $t("lang.onBoarding.finalizing_order") }}
        </span>
        <span v-else>
          {{ $t("lang.onBoarding.first_order_meeting") }}
        </span>
      </h3>
      <h4 class="mb-4" v-if="!simplify && false">
        {{ $t("lang.label.summary") }}
      </h4>

      <!-- Switch / Close order -->
      <div class="col-12 mt-4" v-if="hasPermissions('superAdminTargets') && onBoarding.validationTarget.status == 1">
        <div class="float-right">
          <vue-form-generator
            :schema="schemaCloseOrder"
            :model="onBoarding"
            @model-updated="saveOrderClosed()"
          >
          </vue-form-generator>
        </div>
      </div>


      <div class="row" v-if="simplify && onBoarding.orderId">
        <div class="col-6">
          <h4 class="my-4 float-left">{{ $t("lang.label.edit") }}</h4>
        </div>
      </div>
      <div class="row my-2" v-if="simplify">
        <div class="col-12">
          {{ $t("lang.column.status") }}:
          <span
            v-if="target_status_id == 1"
            class="badge badge-primary text-white px-3 py-2"
          >
            {{ $t("lang.targets.active") }}</span
          >
          <span
            v-if="target_status_id == 2"
            class="badge badge-danger text-white px-3 py-2"
          >
            {{ $t("lang.targets.stopped") }}</span
          >
          <span
            v-if="target_status_id == 3"
            class="badge badge-secondary text-white px-3 py-2"
          >
            {{ $t("lang.targets.pending") }}</span
          >
          <span
            v-if="target_status_id == 4"
            class="badge badge-success text-white px-3 py-2"
          >
            {{ $t("lang.targets.running") }}</span
          >
          <span
            v-if="target_status_id == 5"
            class="badge badge-warning text-white px-3 py-2"
          >
            {{ $t("lang.targets.archived") }}</span
          >
          <!-- <span
            v-if="target_status_id == 6"
            class="badge badge-warning text-white px-3 py-2"
          >
            {{ $t("lang.targets.paused") }}</span
          > -->
        </div>
      </div>
      <!-- Order name -->
      <div class="row my-2">
        <div class="col-12">
          {{ $t("lang.orders.name") }}:<i class="text-danger">*</i>

          <strong
            v-if="!isOpen('orderName')"
            class="text-primary border-0 pl-0 ml-2"
          >
            {{ onBoarding.orderName }}
          </strong>
          <span v-else-if="isOpen('orderName')">
            <input
              min="1"
              max="100"
              class="text-primary mx-2 text-center"
              type="text"
              :value="onBoarding.orderName"
              @input="changeOrderName"
            />
          </span>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              d-inline
            "
            type="button"
            v-if="!isOpen('orderName') && !disabledEdit()"
            @click="openEdit('orderName')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('orderName')"
            @click="closeEdit('orderName')"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>

      <!-- Promotion -->
      <div class="row my-2">
        <div class="col-12">
          <span class="d-inline">
            {{ $t("lang.onBoarding.step1_2_question") }}:<i class="text-danger"
              >*</i
            >
          </span>
          <span>
            <div
              class="wrapper"
              v-if="onBoarding.step3.tag_id || isOpen('whatToPromote')"
            >
              <select
                v-model="onBoarding.step3.tag_id"
                :disabled="!isOpen('whatToPromote')"
                :class="
                  !isOpen('whatToPromote')
                    ? 'border-0 text-primary bg-white'
                    : ''
                "
                class="d-inline form-control"
                @change="changeTagId"
                v-if="tag_2 !== undefined"
              >
                <option
                  v-for="(tag, i) in tag_2.data"
                  :key="`Tag${i}`"
                  :value="tag.id"
                  class="optionSelect"
                >
                  {{ tag.name }}
                </option>
              </select>
            </div>
          </span>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              border-0
              d-inline
            "
            :class="onBoarding.step3.tag_id ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('whatToPromote') && !disabledEdit()"
            @click="openEdit('whatToPromote')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('whatToPromote')"
            @click="closeEdit('whatToPromote')"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>

      <!-- Product name -->
      <div class="row my-2">
        <div class="col-12">
          {{ $t("lang.token.product_name") }}:<i class="text-danger">*</i>
          <strong
            v-if="!isOpen('productName')"
            class="text-primary border-0 pl-0 ml-2"
          >
            {{ onBoarding.productName }}
          </strong>
          <span v-else-if="isOpen('productName')">
            <input
              min="1"
              max="100"
              class="form-control"
              type="text"
              :value="onBoarding.productName"
              @input="changeProductName"
            />
          </span>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              border-0
              btn-sm btn-secondary
              d-inline
            "
            :class="onBoarding.productName ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('productName') && !disabledEdit()"
            @click="openEdit('productName')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('productName')"
            @click="closeEdit('productName')"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            :disabled="onBoarding.productName == ''"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>

      <!-- Name Company -->
      <div class="row my-2">
        <div class="col-12">
          {{ $t("lang.label.companyname") }}:
          <span class="text-primary border-0 pl-0 ml-2"
            >{{ onBoarding.companyName }}
          </span>
        </div>
      </div>
      <!-- Url Web Page -->
      <div class="row my-2">
        <div class="col-12 py-1">
          {{ $t("lang.label.landingPage") }}:<i class="text-danger">*</i>
          <a
            class="text-primary pl-0 ml-2"
            target="_blank"
            type="button"
            v-if="!isOpen('website')"
            :href="onBoarding.website"
          >
            {{ onBoarding.website }}
          </a>
          <span class="my-0 py-0" v-if="isOpen('website')">
            <vue-form-generator
              class="d-inline-block mx-2"
              ref="websiteForm"
              :schema="schemaWebsite"
              :model="modelform"
              :options="formOptions"
            ></vue-form-generator>
          </span>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              d-inline
              border-0
            "
            :class="onBoarding.website ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('website') && !disabledEdit()"
            @click="openEdit('website')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('website')"
            :disabled="modelform.website == '' || formValidation.urlIsValid"
            @click="changeWebsite()"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
        </div>
        <div class="col-12 my-0 py-0">
          <span v-if="formValidation.urlIsValid" class="text-danger">{{
            $t("lang.orders.url_invalid")
          }}</span>
        </div>
      </div>
      <!-- Description Sell -->
      <div class="row my-2">
        <div class="col-12">
          {{ $t("lang.orders.description_sell") }}:<i class="text-danger">*</i>

          <strong
            v-if="!isOpen('orderDescriptionSell')"
            class="text-primary border-0 pl-0 ml-2"
          >
            <span v-if="onBoarding.descriptionSell"
              >{{ onBoarding.descriptionSell.substr(0, 20) }} ...</span
            >
          </strong>
          <p v-else-if="isOpen('orderDescriptionSell')">
            <textarea
              class="form-control"
              name=""
              rows="3"
              :value="onBoarding.descriptionSell"
              @input="changeDescriptionSell"
            >
            </textarea>
          </p>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              d-inline
            "
            :class="onBoarding.descriptionSell ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('orderDescriptionSell') && !disabledEdit()"
            @click="openEdit('orderDescriptionSell')"
          >
            <i class="icon-pencil"></i>
          </button>
          <div v-if="isOpen('orderDescriptionSell')" class="ml-0 mt-0">
            <div class="mt-2">
              <button
                :disabled="
                  !onBoarding.descriptionSell || !correctNumberCharacters
                "
                @click="closeEdit('orderDescriptionSell')"
                class="ml-1 mt-0 btn cursor-pointer btn-sm btn-success d-inline"
                type="button"
              >
                <i class="icon-check1"></i> {{ $t("lang.button.save") }}
              </button>
              <small
                class="ml-3 pt-2 font-weight-bold"
                :class="{
                  'text-success': correctNumberCharacters,
                  'text-danger': !correctNumberCharacters,
                }"
                >{{ textQtyCharacters }}</small
              >
            </div>
          </div>
        </div>
      </div>

      <!-- OFFER CLIENT POTENTIAL -->
      <div class="row my-2">
        <div class="col-12">
          <span class="d-inline">
            {{ $t("lang.onBoarding.offer_client_potential") }}:<i class="text-danger"
              >*</i
            >
          </span>
          <span>
            <div
              class="wrapper"
              v-if="onBoarding.offer_prospect || isOpen('potentialClient')"
            >
              <select
                v-model="onBoarding.offer_prospect"
                :disabled="!isOpen('potentialClient')"
                :class="
                  !isOpen('potentialClient')
                    ? 'border-0 text-primary bg-white'
                    : ''
                "
                class="d-inline form-control"
                @change="changeOfferProspect"

              >
                <option
                  v-for="(offer, i) in select_offer_prospect"
                  :key="offer.id"
                  :value="offer.id"
                  class="optionSelect"
                >
                  {{ offer.label }}
                </option>
              </select>
            </div>
          </span>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              border-0
              d-inline
            "
            :class="onBoarding.step3.tag_id ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('potentialClient') && !disabledEdit()"
            @click="openEdit('potentialClient')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('potentialClient')"
            @click="closeEdit('potentialClient')"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>
      <!-- Fill in the main benefits of your offer -->
      <div class="row my-2">
        <div class="col-12">
          {{ $t("lang.onBoarding.benefits_offer") }}:<i class="text-danger">*</i>

          <strong
            v-if="!isOpen('benefecitYourOffer')"
            class="text-primary border-0 pl-0 ml-2"
          >
            <span v-if="onBoarding.offer_benefits"
              >{{ onBoarding.offer_benefits.substr(0, 20) }} ...</span
            >
          </strong>
          <p v-else-if="isOpen('benefecitYourOffer')">
            <textarea
              class="form-control"
              name=""
              rows="3"
              :value="onBoarding.offer_benefits"
              @input="changeBenefitsOffer"
            >
            </textarea>
          </p>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              d-inline
            "
            :class="onBoarding.offer_benefits ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('benefecitYourOffer') && !disabledEdit()"
            @click="openEdit('benefecitYourOffer')"
          >
            <i class="icon-pencil"></i>
          </button>
          <div v-if="isOpen('benefecitYourOffer')" class="ml-0 mt-0">
            <div class="mt-2">
              <button
                :disabled="
                  !onBoarding.offer_benefits || !correctNumberCharactersGlobal(onBoarding.offer_benefits)
                "
                @click="closeEdit('benefecitYourOffer')"
                class="ml-1 mt-0 btn cursor-pointer btn-sm btn-success d-inline"
                type="button"
              >
                <i class="icon-check1"></i> {{ $t("lang.button.save") }}
              </button>
              <small
                class="ml-3 pt-2 font-weight-bold"
                :class="{
                  'text-success': correctNumberCharactersGlobal(onBoarding.offer_benefits),
                  'text-danger': !correctNumberCharactersGlobal(onBoarding.offer_benefits),
                }"
                >{{ textQtyCharactersGlobal(onBoarding.offer_benefits) }}</small
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Fill in some evidence that makes your offer more attractive than others -->
      <div class="row my-2">
        <div class="col-12">
          {{ $t("lang.onBoarding.offer_attractive") }}:<i class="text-danger">*</i>

          <strong
            v-if="!isOpen('offerMoreAttractive')"
            class="text-primary border-0 pl-0 ml-2"
          >
            <span v-if="onBoarding.offer_attractive"
              >{{ onBoarding.offer_attractive.substr(0, 20) }} ...</span
            >
          </strong>
          <p v-else-if="isOpen('offerMoreAttractive')">
            <textarea
              class="form-control"
              name=""
              rows="3"
              :value="onBoarding.offer_attractive"
              @input="changeOfferAttractive"
            >
            </textarea>
          </p>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              d-inline
            "
            :class="onBoarding.offer_attractive ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('offerMoreAttractive') && !disabledEdit()"
            @click="openEdit('offerMoreAttractive')"
          >
            <i class="icon-pencil"></i>
          </button>
          <div v-if="isOpen('offerMoreAttractive')" class="ml-0 mt-0">
            <div class="mt-2">
              <button
                :disabled="
                  !onBoarding.offer_attractive || !correctNumberCharactersGlobal(onBoarding.offer_attractive)
                "
                @click="closeEdit('offerMoreAttractive')"
                class="ml-1 mt-0 btn cursor-pointer btn-sm btn-success d-inline"
                type="button"
              >
                <i class="icon-check1"></i> {{ $t("lang.button.save") }}
              </button>
              <small
                class="ml-3 pt-2 font-weight-bold"
                :class="{
                  'text-success': correctNumberCharactersGlobal(onBoarding.offer_attractive),
                  'text-danger': !correctNumberCharactersGlobal(onBoarding.offer_attractive),
                }"
                >{{ textQtyCharactersGlobal(onBoarding.offer_attractive) }}</small
              >
            </div>
          </div>
        </div>
      </div>




      <!-- Appointment -->
      <div class="row my-1">
        <div class="col-12">
          <span v-if="!isOpen('appointment')">
            {{ $t("lang.onBoarding.expected_value_appointments") }}:
            <b class="text-primary">{{ onBoarding.step3.appointmentVolume }}</b>
            /
            {{ $t("lang.label.month") }}
          </span>
          <span v-else-if="isOpen('appointment')">
            <span class="bg-white border-0 pl-0 ml-3"
              >{{ $t("lang.onBoarding.expected_value_appointments") }}
            </span>
            <span class="mx-2">
              <div class="wrapper">
                <input
                  min="10"
                  max="100"
                  class="form-control"
                  type="number"
                  v-model="onBoarding.step3.appointmentVolume"
                  @input="changeAppointmentVolume"
                />
              </div>
            </span>

            <span class="bg-white border-0 pl-0 pt-0">
              / {{ $t("lang.label.month") }}
            </span>
          </span>

          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              d-inline
            "
            type="button"
            v-if="!isOpen('appointment') && !disabledEdit()"
            @click="openEdit('appointment')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('appointment')"
            @click="closeEdit('appointment')"
            :disabled="onBoarding.step3.appointmentVolume == '' || formValidation.appointment"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
        </div>
        <div class="col-12 my-0 py-0">
          <span v-if="formValidation.appointment"  class="text-danger">{{$t("lang.orders.appointment_invalid")}}</span>
        </div>
      </div>
      <!-- Launch Date -->
      <div class="row my-1">
        <div class="col-12">
          <span v-if="!isOpen('launchDate')">
            {{ $t("lang.onBoarding.launch_date_campaign") }}:<i
              class="text-danger"
              >*</i
            >
            <b
              class="text-primary ml-2"
              style="
                width: 98px !important;
                overflow: hidden;
                display: inherit;
                height: 18px;
              "
              >{{ onBoarding.step3.launchDate }}
            </b>
          </span>
          <span v-else-if="isOpen('launchDate')">
            <span class="bg-white border-0 pl-0"
              >{{ $t("lang.onBoarding.launch_date_campaign") }}:
            </span>
            <vue-form-generator
              class="d-inline-block mx-4"
              ref="launchDateForm"
              :schema="schemaStatus"
              :model="modelform"
              :options="formOptions"
            ></vue-form-generator>
          </span>
          <button
            class="
              ml-2
              btn
              rounded-circle
              cursor-pointer
              btn-sm
              border-0
              btn-secondary
            "
            :class="onBoarding.step3.launchDate ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('launchDate') && !disabledEdit()"
            @click="openEdit('launchDate')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('launchDate')"
            @click="changeLaunchDate()"
            :disabled="
              onBoarding.step3.launchDate == '' ||
              ($refs.launchDateForm !== undefined &&
                $refs.launchDateForm.errors.length > 0)
            "
            class="ml-1 btn cursor-pointer btn-sm btn-success"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>

      <!-- Language -->
      <div class="row my-2">
        <div class="col-12">
          {{ $t("lang.label.language") }}:<i class="text-danger">*</i>
          <span
            v-if="!isOpen('language') && onBoarding.lang !== ''"
            class="text-primary bg-white border-0 pl-0 ml-2"
          >
            {{ this.$t("lang.onBoarding.lang." + onBoarding.lang) }}
          </span>
          <span v-else-if="isOpen('language')">
            <select v-model="onBoarding.lang" class="langSelect form-control">
              <option
                v-for="(lang, i) in langs"
                :key="`Lang${i}`"
                :value="lang.type"
                class="optionSelect"
              >
                {{ lang.label }}
              </option>
            </select>
          </span>
          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              d-inline
              border-0
            "
            :class="onBoarding.lang ? '' : 'bg-danger'"
            type="button"
            v-if="!isOpen('language') && !disabledEdit() && (this.target_status_id == 3 || this.target_status_id==null  )"
            @click="openEdit('language')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('language')"
            @click="changeLanguage(true)"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>
      <!-- <div class="row my-2">
        <div class="col-12">
          <span>
            {{ $t("lang.onBoarding.my_price_appointment") }}
            <b class="text-primary"
              >{{ onBoarding.step3.appointmentPrice }}€ H.T / rendez-vous</b
            >
          </span>
        </div>
      </div> -->

      <!-- Price -->
      <div class="row my-2">
        <div class="col-12">
          <span v-if="!isOpen('editingAppointPrice')">
            {{ $t("lang.onBoarding.my_price_appointment") }}
            <b class="text-primary"
              >{{ onBoarding.step3.appointmentPrice }} €
              {{ $t("lang.label.net") }} / {{ $t("lang.label.meeting") }}</b
            >
            <b class="text-primary ml-1" v-if="false">
              ({{
                $t("lang.onBoarding.prospects", {
                  prospects: new Intl.NumberFormat("es-ES").format(
                    onBoarding.apollo.total_result
                  ),
                })
              }})
            </b>
          </span>
          <span v-else-if="isOpen('editingAppointPrice')">
            <span class="bg-white border-0 pl-0"
              >{{ $t("lang.onBoarding.my_price_appointment") }}
            </span>

            <span class="mx-2">
              <div class="wrapper">
                <input
                  min="1"
                  max="500"
                  class="form-control"
                  type="number"
                  :value="onBoarding.step3.appointmentPrice"
                  @input="changeAppointmentPrice"
                />
              </div>
            </span>
          </span>

          <button
            class="
              ml-1
              btn
              rounded-circle
              cursor-pointer
              btn-sm btn-secondary
              d-inline
            "
            type="button"
            v-if="
              !isOpen('editingAppointPrice') &&
              hasPermissions('superAdminTargets') &&
              simplify
            "
            @click="openEdit('editingAppointPrice')"
          >
            <i class="icon-pencil"></i>
          </button>
          <button
            v-if="isOpen('editingAppointPrice')"
            @click="closeEdit('editingAppointPrice')"
            class="ml-1 btn cursor-pointer btn-sm btn-success d-inline"
            type="button"
          >
            <i class="icon-check1"></i> {{ $t("lang.button.save") }}
          </button>
          <div
            class="row my-2"
            v-if="
              hasPermissions('superAdminTargets') &&
              (onBoarding.target_status_id == 1 ||
                onBoarding.target_status_id == 4)
            "
          >
            <div class="col-12">
              Verified:
              <span
                v-if="!isOpen('verified')"
                class="text-primary bg-white border-0 pl-0"
              >
                {{ verificationOrder.label }}
              </span>
              <span v-else-if="isOpen('verified')">
                <StatusComment
                  :status="verificationOrder.status"
                  :comments="verificationOrder.comment"
                  @onChange="changeVerificateOrder(...arguments)"
                />
              </span>
              <button
                class="
                  ml-1
                  btn
                  rounded-circle
                  cursor-pointer
                  btn-sm btn-secondary
                  d-inline
                "
                type="button"
                v-if="!isOpen('verified')"
                @click="openEdit('verified')"
              >
                <i class="icon-pencil"></i>
              </button>
              <button
                v-if="isOpen('verified')"
                @click="verificateOrder()"
                class="
                  ml-1
                  btn
                  rounded-circle
                  cursor-pointer
                  btn-sm btn-success
                  d-inline
                "
                type="button"
              >
                <i class="icon-check1"></i>
              </button>
            </div>
            <!-- aqui va estatus -->
          </div>
        </div>
      </div>
      <!-- MODAL E-MAILS -->
      <Modal :name="'mails'">
        <div class="px-4 d-inline">
          <Tabs
            :tabSelected="onBoarding.modelCampaingStep.tabSelected.id"
            :tabs="tabs"
            @change="changeTab($event)"
          />
        </div>
        <div
          class="text-align-center p-4"
          v-if="onBoarding.modelCampaingStep.tabSelected.id == 1"
        >
          <div class="card mb-5">
            <CustomMsg
              :availableTokens="availableTokens.data"
              :availableTokensSelect="availableTokens.data"
              :model="onBoarding.modelCampaingStep"
              :onboarding="true"
              @update="saveTargetCampaignStep($event)"
            />
          </div>
        </div>
        <div
          class="p-4 text-left"
          v-if="onBoarding.modelCampaingStep.tabSelected.id == 2"
        >
          <h4 class="card-title text-primary mb-2">
            {{ $t("lang.onBoarding.mails_modal_title") }}
          </h4>
          <span class="text-secondary mb-3">{{
            $t("lang.onBoarding.mails_modal_description")
          }}</span>

          <div class="row">
            <div
              class="col-md-5 p-0"
              :class="{ 'border border-warning rounded': step1hasError }"
            >
              <div
                v-if="step1hasError"
                class="
                  row
                  my-3
                  mx-3
                  py-1
                  bg-warning
                  text-dark text-bold text-center
                "
              >
                <div class="col-8">
                  <span class="pt-1 font-weight-bold">{{
                    $t("lang.onBoarding.complete_this_before_campaign")
                  }}</span>
                </div>
                <div class="col-3">
                  <button
                    class="
                      btn
                      large
                      cursor-pointer
                      font-weight-bolder
                      btn-sm btn-light
                      mx-1
                    "
                    @click="goToSubStep(1, 0)"
                  >
                    {{ $t("lang.onBoarding.go_step_by_step") }}
                  </button>
                </div>
              </div>
              <Step1Summary @save="mailmodalkey++" />
            </div>
            <div class="col-md-7">
              <!-- <TargetStepCampaingPreview
                v-if="
                  !disabledEdit() &&
                  previewTemplate() &&
                  !loading
                "
                :model="modelCampaingStep"
                :availableTokens="availableTokens"
                :preview="false"
                :availableTokensSelect="availableTokens"
              /> -->
              <MailsModal :key="mailmodalkey" :tag_id="tag_id" />
            </div>
            <button
              class="
                float-right
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-primary
                m-1
                px-4
              "
              type="button"
              @click="
                savenow(false, false);
                closeModal('mails');
              "
              v-if="!disabledEdit()"
            >
              {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>
      </Modal>

      <Modal :name="'videotraining'" :close="false">
        <div v-if="!training_step1" class="col-sm-8 offset-2">
          <h3 class="text-primary text-center">
            {{ $t("lang.training.title") }}
          </h3>

          <p class="text-center">{{ $t("lang.training.descripcion") }}</p>
          <div class="text-center text-dark mt-2 mb-2">
            <h5>{{ $t("lang.training.step2_3") }}</h5>
          </div>

          <div class="embed-responsive embed-responsive-16by9">
            <!-- <iframe v-if="false" class="embed-responsive-item" src="https://www.youtube.com/embed/CrMAy18VRg4"
                      allowfullscreen></iframe> -->
            <VideoToolToy
              :url="'https://player.vimeo.com/video/752951255?h=4071c1caf8'"
              :autoplay="true"
            />
          </div>
          <div class="text-center mb-5">
            <button
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-primary
                mr-5
                m-1
                mt-2
                px-4
              "
              v-on:click="training_step1 = true"
            >
              {{ $t("lang.training.step1_button") }}
            </button>
          </div>
        </div>
        <div v-else class="col-sm-8 offset-2">
          <h3 class="text-primary text-center">
            {{ $t("lang.training.title") }}
          </h3>

          <p class="text-center">{{ $t("lang.training.descripcion") }}</p>
          <div class="text-center text-dark mt-2 mb-2">
            <h5>{{ $t("lang.training.step2_3") }}</h5>
          </div>

          <div class="embed-responsive embed-responsive-16by9">
            <!-- <iframe v-if="false" class="embed-responsive-item" src="https://www.youtube.com/embed/CrMAy18VRg4"
                      allowfullscreen></iframe> -->
            <VideoToolToy
              :url="'https://player.vimeo.com/video/752950831?h=048a3561aa'"
              :autoplay="true"
            />
          </div>

          <div>
            <div class="mt-2 mb-5 d-flex flex-column">
              <h6 class="text-secondary">
                <input
                  class="d-inline mr-2 mt-2 cursor-pointer"
                  type="checkbox"
                  v-model="training_check"
                />
                {{ $t("lang.training.term_1") }}
                <a
                  target="_blank"
                  class="text-primary"
                  href="https://help.oliverlist.com/knowledge/signalement-des-rendez-vous-hors-scope"
                  >{{ $t("lang.training.term_1_link") }}</a
                >
              </h6>
              <h6 class="text-secondary">
                <input
                  class="d-inline mr-2 mt-2 cursor-pointer"
                  type="checkbox"
                  v-model="trainingCheck_2"
                />
                {{ $t("lang.training.term_1") }}
                <a
                  target="_blank"
                  class="text-primary"
                  href="https://help.oliverlist.com/knowledge/signalement-des-rendez-vous-absents"
                  >{{ $t("lang.training.term_2_link") }}</a
                >
              </h6>
              <h6 class="text-secondary">
                <input
                  class="d-inline mr-2 mt-2 cursor-pointer"
                  type="checkbox"
                  v-model="trainingCheck_3"
                />
                {{ $t("lang.training.term_3") }}
              </h6>
            </div>
            <div class="text-center mb-5">
              <button
                class="
                  btn
                  cursor-pointer
                  font-weight-bolder
                  btn-sm btn-primary
                  mr-5
                  m-1
                  mt-2
                  px-4
                "
                v-on:click="trainingPass()"
              >
                {{ $t("lang.training.step2_button") }}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal :name="'start-campaings'" :close="false">
        <div class="row justify-content-center" v-if="loadingEmailSequence">
          <div class="col-1">
            <LoadingSpinner class="mr-5" v-if="loadingEmailSequence" />
            <span class="mb-5 -mt-5" v-if="loadingEmailSequence">{{
              $t("lang.search.loading")
            }}</span>
          </div>
        </div>

        <div v-if="!loadingEmailSequence">
          <div class="row p-4 justify-content-center">
            <div class="col text-center mt-3">
              <h4 class="mx-3">
                {{ $t("lang.onBoarding.confirmemailsequence") }}
              </h4>
            </div>
          </div>
          <div class="row p-4 justify-content-center">
            <div class="col-md-8">
              <div class="bg-light text-dark rounded p-2">
                <img src="@/assets/images/2 (1).png" width="50px" alt="" />
                <p class="d-inline p-2 font-weight-bold">OliverTips</p>
                <p class="p-2">
                  {{ $t("lang.onBoarding.emailsequencetip") }}
                </p>
              </div>
            </div>
          </div>
          <div class="row justify-content-center p-4">
            <div class="col-md-8">
              <MailsModal
                :key="mailmodalkey"
                :simplify="true"
                :tag_id="tag_id"
              />
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-7">
              <div class="display mt-2 mb-5">
                <h6 class="text-secondary">
                  <input
                    class="d-inline mr-2 mt-2 cursor-pointer"
                    type="checkbox"
                    v-model="oliverEmailSequence"
                  />
                  {{ $t("lang.onBoarding.checkemailsequence") }}
                </h6>
              </div>

              <button
                class="
                  btn
                  cursor-pointer
                  font-weight-bolder
                  btn-sm btn-secondary
                  mr-5
                  m-1
                  mt-2
                  px-4
                "
                type="button"
                @click="$modal.hide('start-campaings'), $modal.show('mails')"
              >
                {{ $t("lang.button.gobackedit") }}
              </button>
              <button
                class="
                  btn
                  cursor-pointer
                  font-weight-bolder
                  btn-sm btn-primary
                  m-1
                  ml-5
                  mt-2
                  px-4
                "
                :disabled="oliverEmailSequence ? false : true"
                type="button"
                @click="savenow(true, true), (loadingEmailSequence = true)"
              >
                {{ $t("lang.onBoarding.start_preparing_my_campaigns") }}
                <span class="img-btn">
                  <img src="@/assets/images/icono-wp.png" alt />
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <!-- MODAL FALTANTE DE DATOS -->
      <Modal :name="'Errors'" :resizable="true" height="auto" width="40%">
        <div class="row p-4 text-left">
          <div class="col text-center mt-3">
            <h4 class="mx-3">{{ $t("lang.label.missingdata") }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card-body pt-1">
              <div class="row justify-content-center">
                <div class="col-md-8">
                  <div id="accordion">
                    <div class="card" v-if="!onBoarding.step1Ready">
                      <div
                        class="card-header alert alert-dange mb-0"
                        id="headingOne"
                      >
                        <h5 class="mb-0">
                          <button
                            class="btn btn-link"
                            data-toggle="collapse"
                            data-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            {{ $t("lang.onBoarding.describe_your_services") }}
                          </button>
                        </h5>
                      </div>

                      <div
                        id="collapseOne"
                        class="collapse show"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li
                            class="list-group-item border-0"
                            v-if="!onBoarding.productName"
                          >
                            <i class="icon-circle mr-1 text-danger"></i>

                            {{ $t("lang.token.product_name") }}
                          </li>
                            <li
                            class="list-group-item border-0"
                            v-if="!onBoarding.step3.tag_id"
                          >
                            <i class="icon-circle mr-1 text-danger"></i>
                             {{ $t("lang.onBoarding.step1_2_question") }}

                          </li>
                        </div>
                        <div class="card-body" v-if="false">
                          <li
                            class="list-group-item border-0"
                            v-if="!onBoarding.step3.tag_id"
                          >
                            <i class="icon-circle mr-1 text-danger"></i>

                            <button
                              v-if="!simplify"
                              class="btn btn-sm btn-primary float-right ml-2"
                              @click="goToSubStep(1, 1)"
                            >
                              {{ $t("lang.onBoarding.gotostep", { step: "" }) }}
                            </button>
                          </li>

                          <li
                            class="list-group-item border-0"
                            v-if="onBoarding.productName == ''"
                          >
                            <i class="icon-circle mr-1 text-danger"></i>
                            {{ $t("lang.onBoarding.step1_1_question") }}
                            <button
                              class="btn btn-sm btn-primary float-right ml-2"
                              @click="goToSubStep(1, 1)"
                            >
                              {{ $t("lang.onBoarding.gotostep", { step: "" }) }}
                            </button>
                          </li>

                          <li
                            v-for="item in onBoarding.descriptions"
                            class="list-group-item border-0"
                            v-if="
                              !onBoarding.step1[item.arg] && item.order == 1
                            "
                          >
                            <i class="icon-circle mr-1 text-danger"></i>
                            {{
                              $t(
                                "lang.onBoarding." + item.arg + "_prepend",
                                onBoarding.lang
                              )
                            }}
                            ...
                            <button
                              v-if="!simplify"
                              class="btn btn-sm btn-primary float-right ml-2"
                              @click="goToSubStep(1, item.substep)"
                            >
                              {{ $t("lang.onBoarding.gotostep", { step: "" }) }}
                            </button>
                          </li>
                        </div>
                      </div>
                    </div>
                    <div
                      class="card"
                      v-if="
                        onBoarding.step3.teamMembers.length == 0 &&
                        onBoarding.typeForm == 'onboarding'
                      "
                    >
                      <div class="card-header mb-0" id="headingTwo">
                        <h5 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            {{ $t("lang.onBoarding.who_is_thesales") }}
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li class="list-group-item border-0">
                            <i class="icon-circle mr-1 text-danger"></i>
                            {{ this.$t("lang.orders.unavailablesales") }}
                          </li>
                        </div>
                      </div>
                    </div>
                    <div
                      class="card"
                      v-if="
                        onBoarding.step3.updateSales.length == 0 &&
                        onBoarding.typeForm != 'onboarding'
                      "
                    >
                      <div class="card-header mb-0" id="headingTwo">
                        <h5 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            {{ $t("lang.onBoarding.who_is_thesales") }}
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li class="list-group-item border-0">
                            <i class="icon-circle mr-1 text-danger"></i>
                            {{ this.$t("lang.orders.unavailablesales") }}
                          </li>
                        </div>
                      </div>
                    </div>
                    <div
                      class="card"
                      v-if="
                        !onBoarding.step2Ready
                      "
                    >
                      <div class="card-header mb-0" id="headingTwo">
                        <h5 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            {{ $t("lang.onBoarding.what_are_your_targets") }}
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li class="list-group-item border-0">
                            <i class="icon-circle mr-1 text-danger"></i>
                            {{
                              this.$t("lang.onBoarding.targeting_criteria")
                            }}
                            <!-- <button
                              class="btn btn-sm btn-primary float-right ml-2"
                              @click="goToSubStep(2, 1)"
                              v-if="!simplify"
                            >
                              {{ $t("lang.onBoarding.gotostep", { step: "" }) }}
                            </button> -->
                          </li>
                        </div>
                      </div>
                    </div>
                    <div class="card" v-if="onBoarding.step3.launchDate == ''">
                      <div class="card-header mb-0" id="headingThree">
                        <h5 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            {{ $t("lang.label.summary") }}
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseThree"
                        class="collapse show"
                        aria-labelledby="headingThree"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li class="list-group-item border-0">
                            <i class="icon-circle mr-1 text-danger"></i>
                            {{
                              this.$t("lang.onBoarding.launch_date_campaign")
                            }}
                          </li>
                        </div>
                      </div>
                    </div>
                    <div
                      class="card"
                      v-if="
                        onBoarding.website == '' || onBoarding.website == null
                      "
                    >
                      <div class="card-header mb-0" id="headingThree">
                        <h5 class="mb-0">
                          <button
                            class="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            {{ $t("lang.label.landingPage") }}
                          </button>
                        </h5>
                      </div>
                      <div
                        id="collapseThree"
                        class="collapse show"
                        aria-labelledby="headingThree"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <li class="list-group-item border-0">
                            <i class="icon-circle mr-1 text-danger"></i>
                            {{ $t("lang.label.landingPage") }}
                          </li>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <!-- MODAL Targets -->
      <Modal :name="'targets'" @closeModal="closeModal">
        <div class="p-4 text-left">
          <h3 class="card-title text-primary mb-2">
            {{ $t("lang.onBoarding.target_modal_title") }}
          </h3>
          <p class="text-secondary mb-3">
            {{ $t("lang.onBoarding.target_modal_description") }}
          </p>
          <div class="row">
            <div class="col-md-5">
              <div class="card">
                <div class="card-body">
                  <Step2Summary
                    :key="step2sum"
                    :poupView="true"
                    @change="refreshTarget($event)"
                    :selectDisable="false"
                    @save="savenow(false, false)"
                  />
                  <button
                    class="
                      float-right
                      btn
                      cursor-pointer
                      font-weight-bolder
                      btn-sm btn-primary
                      m-1
                      mt-4
                      px-4
                    "
                    type="button"
                    @click="
                      savenow(false, false);
                      closeModal('targets');
                    "
                    v-if="!disabledEdit()"
                  >
                    {{ $t("lang.button.save") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-7">
              <TargetsModal
                v-if="!onBoarding.loading"
                :key="targetkey"
                :contactkey="targetkey + 1"
                :contacts="apolloResult"
              />
            </div>
          </div>
        </div>
      </Modal>
      <div class="card my-4" v-if="!simplify && !addOrder">
        <div class="card-title mx-3 mt-3">
          <h5>
            {{ $t("lang.onBoarding.people_in_team_receiving_appointments") }}
          </h5>
        </div>

        <TeamMembers @save="savenow(false, false)" />
      </div>
      <div class="card my-4 p-3" v-if="simplify || addOrder">
        {{ $t("lang.onBoarding.who_is_thesales") }}
        <LoadingSpinner v-if="loadingSales" />
        <IndustrySearch
          v-if="!loadingSales"
          :option_list="salesRep"
          :default_values="modelform.sales"
          :isDisabled="disabledEditSales()"
          @closed="updateSales(modelform.sales)"
        >
        </IndustrySearch>
        <small class="text-danger my-3" v-if="salesRep.length == 0">
          {{ $t("lang.orders.unavailablesales") }}</small
        >
      </div>
      <div class="row mt-4">
        <div class="col-md-6 pr-2">
          <div class="card">
            <div class="row">
              <div class="col-12">
                <div class="float-right">
                  <vue-form-generator
                    ref="annualSubscription"
                    :schema="schemaPreviewTemplate"
                    :model="onBoarding"
                    :options="formOptions"
                  >
                  </vue-form-generator>
                </div>
              </div>
              <div class="col-12" v-if="hasPermissions('superAdminTargets')">
                <div class="float-right mr-5 px-"></div>
              </div>

              <div class="col-12">
                <div class="m-3">
                  <button
                    v-if="!loading && hasPermissions('superAdminTargets')"
                    class="
                      float-right
                      btn
                      rounded-circle
                      ml-1
                      cursor-pointer
                      btn-sm btn-primary
                    "
                    @click="showModal('mails')"
                    type="button"
                  >
                    <i class="icon-expand"></i>
                  </button>
                  <button
                    v-if="!loading && hasPermissions('superAdminTargets')"
                    class="
                      mr-2
                      float-right
                      btn
                      rounded-circle
                      cursor-pointer
                      btn-sm btn-secondary
                    "
                    @click="editStep(1)"
                    type="button"
                  >
                    <i class="icon-pencil"></i>
                  </button>
                  <h5 class="d-inline">
                    {{ $t("lang.orders.sequence") }}
                  </h5>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div v-if="!loading && verificationOrder.status == 1 && previewTemplate()">
                <TargetStepCampaingPreview
                  v-if="onBoarding.modelCampaingStep.tabSelected.id == 1"
                  :model="onBoarding.modelCampaingStep"
                  :availableTokens="availableTokens"
                  :preview="true"
                  :availableTokensSelect="availableTokens"
                />

                <PreviewEmail
                  class="p-4"
                  :tag_id="Number(tag_id)"
                  :templateId="1"
                  v-else
                  :resumed="true"
                  :subject="'Re'"
                />
              </div>

              <div v-else>
                <div class="text-center">
                  <span class="mb-4">
                    <img
                      width="20%"
                      src="@/assets/images/Logo-oliver-400.png"
                      class="d-block mx-auto my-2"
                    />
                    <h6>{{ $t("lang.onBoarding.questionsleft") }}</h6></span
                  >
                </div>
                <div class="text-center" v-if="false">
                  <button @click="goToSubStep(1, 1)" class="btn btn-primary">
                    {{ $t("lang.onBoarding.gotostep", { step: "1/3" }) }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-4">
          <div class="card">
            <div class="row">
              <div class="col-12">
                <div class="m-3">
                  <h5 class="d-inline">
                    {{ $t("lang.onBoarding.targeting_criteria") }}
                  </h5>
                  <button
                    class="
                      float-right
                      btn
                      rounded-circle
                      ml-1
                      cursor-pointer
                      btn-sm btn-primary
                    "
                    v-if="!disabledEdit()"
                    @click="showModal('targets')"
                    type="button"
                  >
                    <i class="icon-expand"></i>
                  </button>
                  <button
                    class="
                      mr-2
                      float-right
                      btn
                      rounded-circle
                      cursor-pointer
                      btn-sm btn-secondary
                    "
                    v-if="
                      (!disabledEdit() && false) || currentUser.role_id == 1
                    "
                    @click="editStep(2)"
                    type="button"
                  >
                    <i class="icon-pencil"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <LoadingSpinner v-if="onBoarding.isDisabled" />

              <div v-if="!onBoarding.isDisabled">
              <Step2Summary
                  @change="refreshTarget($event)"
                  :key="step2sum"
                  :selectDisable="disabledEdit()"
                  @save="savenow(false, false)"
                />
              </div>
              <div v-if="false && !onBoarding.step2Ready && !simplify">
                <div class="text-center">
                  <span class="mb-4">{{
                    $t("lang.onBoarding.searchcriteria")
                  }}</span>
                </div>
                <div class="text-center">
                  <button @click="goToSubStep(2, 1)" class="btn btn-primary">
                    {{ $t("lang.onBoarding.gotostep", { step: "2/3" }) }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row my-4" v-if="simplify || addOrder">
        <div class="col-12">
          <div class="btn-group dropleft float-right">
            <button
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-outline-dark
                m-1
                mt-2
                px-4
              "
              v-if="!simplify && addOrder && false"
              type="button"
              @click="goToSubStep(2, 1)"
            >
              {{ $t("lang.button.back") }}
            </button>
            <!-- <button
              v-if="target_status_id == 4 && hasPermissions('adminClients')"
              class="
                  btn
                  btn_pause
                  cursor-pointer
                  font-weight-bolder
                  btn-sm btn-secondary
                  mr-5
                  m-1
                  mt-2
                  px-4
                "
              type="button"
              @click="changeStatus(6)"
            >
              {{ $t("lang.button.paused") }}
            </button> -->
            <!-- <button
              v-if="target_status_id == 6 && hasPermissions('adminClients')"
              class="
                  btn
                  btn_pause
                  cursor-pointer
                  font-weight-bolder
                  btn-sm btn-secondary
                  mr-5
                  m-1
                  mt-2
                  px-4
                "
              type="button"
              @click="changeStatus(4)"
            >
              {{ $t("lang.button.depaused") }}
            </button> -->
            <button
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-primary
                m-1
                mt-2
                px-4
              "
              type="button"
              @click="savenow(false, true)"
              v-if="!disabledEdit()"
            >
              {{ $t("lang.button.save") }}
            </button>
            <button
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-primary
                m-1
                mt-2
                px-4
              "
              type="button"
              @click="savenow(true, true)"
              v-if="target_status_id == 2"
            >
              {{ $t("lang.button.setalive") }}
            </button>
            <button
              v-if="onBoarding.orderId && onBoarding.target_status_id == 3"
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-primary
                m-1
                mt-2
                px-4
              "
              type="button"
              @click="validate()"
            >
              {{ $t("lang.onBoarding.start_preparing_my_campaigns") }}
              <span class="img-btn">
                <img src="@/assets/images/icono-wp.png" alt />
              </span>
            </button>
            <button
              v-if="onBoarding.orderId && !addOrder"
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-secondary
                m-1
                mt-2
                px-4
              "
              type="button"
              @click="duplicate()"
            >
              {{ $t("lang.campaigns_dashboard.copycampaign") }}
            </button>
            <button
              v-if="parseInt(target_status_id) == 5"
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-secondary
                m-1
                mt-2
                px-4
              "
              type="button"
              @click="changeStatus(3)"
            >
              {{ $t("lang.button.restore") }}
            </button>
            <button
              v-if="
                parseInt(target_status_id) == 3 ||
                parseInt(target_status_id) == 2
              "
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-warning
                m-1
                mt-2
                px-4
              "
              type="button"
              @click="changeStatus(5)"
            >
              {{ $t("lang.campaigns_dashboard.archivecampaign") }}
            </button>
            <button
              v-if="
                (parseInt(target_status_id) == 1 ||
                  parseInt(target_status_id) == 4) &&
                hasPermissions('adminAgency') &&
                !addOrder
              "
              class="
                btn
                cursor-pointer
                font-weight-bolder
                btn-sm btn-danger
                m-1
                mt-2
                px-4
              "
              type="button"
              @click="changeStatus(2)"
            >
              {{ $t("lang.button.stop") }}
            </button>
            <Tooltip :text="$t('lang.general.reachouttoourteam')" :width="''">
              <button
                v-if="
                  parseInt(target_status_id) == 1 &&
                  !hasPermissions('adminAgency') &&
                  !addOrder
                "
                class="
                  btn
                  cursor-pointer
                  font-weight-bolder
                  btn-sm btn-danger
                  m-1
                  mt-2
                  px-4
                "
                type="button"
                disabled
              >
                {{ $t("lang.button.stop") }}
              </button>
            </Tooltip>
          </div>
        </div>
      </div>

      <div class="text-center" v-if="!simplify && !addOrder">
        <button
          class="
            btn
            large
            cursor-pointer
            font-weight-bolder
            btn-sm btn-outline-dark
            mx-1
            px-4
          "
          type="button"
          v-if="false"
          @click="goToSubStep(2, 1)"
        >
          {{ $t("lang.button.back") }}
        </button>
        <button
          class="
            btn
            large
            cursor-pointer
            font-weight-bolder
            btn-sm btn-primary
            mx-1
            my-1
            px-4
            mt-4
          "
          type="button"
          @click="validate()"
          v-if="!simplify"
        >
          {{ $t("lang.onBoarding.start_preparing_my_campaigns") }}
          <span class="img-btn">
            <img src="@/assets/images/icono-wp.png" alt />
          </span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import MailsModal from "@/components/Onboarding/MailsModal.vue";
import Tabs from "@/components/Common/Tabs.vue";
import Modal from "@/components/Common/Modal.vue";
import Step1Summary from "@/components/Onboarding/MultiSteps/Step1Summary.vue";
import TargetsModal from "@/components/Onboarding/TargetsModal.vue";
import Step2Summary from "@/components/Onboarding/MultiSteps/Step2Summary.vue";
import TeamMembers from "@/components/Onboarding/TeamMembers.vue";
import { mapState, mapActions } from "vuex";
import PreviewEmail from "@/components/Emails/PreviewEmail.vue";
import TargetStepCampaingPreview from "@/components/Campaigns/TargetStepCampaingPreview.vue";
import CustomMsg from "@/components/AccountCreation/Steps/Campaign/CustomMsg.vue";
import CreditCardForm from "@/components/Billing/CreditCardForm.vue";
import VueFormGenerator from "vue-form-generator";
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import StatusComment from "@/components/Common/StatusComment";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import VideoToolToy from "@/components/Onboarding/VideoToolToy.vue";
import { targetsService, usersService, adminService } from "@/_services";
export default {
  data() {
    var self = this;
    return {
      modelCampaingStep: {
        campaign: {
          is_agency: 1,
        },
        campaign_steps: [
          // {
          //   target_id: this.targetId,
          //   step: "1",
          //   delay: "0",
          //   time_to_send: "8",
          //   subject: "Formation [prospect_first_name] [prospect_last_name]",
          //   message:
          //     "Bonjour [prospect_first_name] [prospect_last_name],\n\nJ'espère que vous allez bien et que la reprise à [prospect_city] est dynamique.\n\n Dans le contexte de la crise, je vous offre une formation Google Business afin de référencer au mieux votre agence [prospect_first_name] [prospect_last_name] et me faire connaître auprès de vous.\n\nVoici un lien personnalisé pour découvrir  mon programme et s'inscrire  : [my_website_url_tracking]\n\nAuriez-vous 10 mn a m'accorder cette semaine pour discuter de votre plan de formation Eligible LOI ALUR.\n\nExcellente journée !",
          //   recall_step: "0",
          // },
        ],
      },
      formValidation: {
        urlIsValid: false,
        appointment: false,
      },
      training_check: false,
      trainingCheck_2: false,
      trainingCheck_3: false,
      training_step1: false,
      oliverEmailSequence: false,
      loadingEmailSequence: false,
      editing: [],
      tabSelect: 1,
      verificationOrder: [],
      step2sum: 2322,
      targetkey: 232232,
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" },
      ],
      apolloResult: false,
      editPrice: false,
      salesRep: [],
      isDisabled: true,
      loadingSales: true,
      selected_sizes: [],
      selectedSales: [],
      activeLanguage: "",
      language: "",
      select_offer_prospect:[
        {
          id:1,
          label : this.$t("lang.onBoarding.offer_1")
        },
        {
          id:2,
          label : this.$t("lang.onBoarding.offer_2")

        },
        {
          id:3,
          label : this.$t("lang.onBoarding.offer_3")
        },
                {
          id:4,
          label : this.$t("lang.onBoarding.offer_4")
        }

      ],
      langs: [
        {
          type: "es",
          label: this.$t("lang.onBoarding.lang.spanish"),
        },
        {
          type: "en",
          label: this.$t("lang.onBoarding.lang.english"),
        },
        {
          type: "fr",
          label: this.$t("lang.onBoarding.lang.french"),
        },
      ],
      // tabs: {
      //   1: {
      //     id: 1,
      //     name: this.$t("lang.label.personalizedsequence"),
      //     disabled: false,
      //   },
      //   2: {
      //     id: 2,
      //     name: this.$t("lang.label.template"),
      //     disabled: false,
      //   },
      // },
      optionSales: [],
      sales: [],
      showTarget: true,
      step1hasError: false,
      editingAppointPrice: false,
      mailmodalkey: 2123,
      emailDataToken: [],
      modelform: {
        launchDate: null,
        sales: [],
        website: null,
        descriptionSell: null,
      },
      schemaStatus: {
        fields: [
          {
            type: "input",
            inputType: "date",
            model: "launchDate",
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.date.locale({
              dateIsEarly: this.$t("lang.onBoarding.dateIsEarly"),
            }),
            format: "YYYY-MM-DD",
            min: moment().add(2, "days").startOf("day"),
          },
        ],
      },
      schemaWebsite: {
        fields: [
          {
            type: "input",
            inputType: "text",
            styleClasses: "my-0 py-0",
            model: "website",
            featured: true,
            required: true,
          },
        ],
      },
      schemaSales: {
        fields: [
          {
            type: "vueMultiSelect",
            model: "sales",
            label: this.$t("lang.onBoarding.who_is_thesales"),
            values: this.selectedSales,
            multiSelect: true,
            selectOptions: {
              multiple: true,
              trackBy: "id",
              label: "first_name",
              taggable: false,
              searchable: false,
              closeOnSelect: false,
              hideSelected: true,
              value: "id",
              name: "first_name",
            },
          },
        ],
      },
      schemaPreviewTemplate: {
        fields: [
          {
            type: "switch",
            label: this.$t("lang.onBoarding.previewtemplate"),
            model: "previewTemplate",
            featured: true,
            id: "previewTemplate",
            textOn: " ",
            textOff: " ",
            valueOn: "1",
            valueOff: "0",
            styleClasses: "col-md-12 display-inline",
            visible() {
              return self.currentUser.role_id == 1;
            },
          },
        ],
      },
      schemaCloseOrder: {
        fields: [
          {
            type: "switch",
            label: this.$t("lang.orders.order_finished"),
            model: "closed",
            featured: true,
            id: "closed",
            textOn: " ",
            textOff: " ",
            valueOn: "1",
            valueOff: "0",
            styleClasses: "col-md-12 display-inline",
            visible() {
              return self.hasPermissions('superAdminTargets');
            },
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },
  watch: {
    "modelform.website"(newValue) {
      if (newValue.includes("linkedin")) {
        this.formValidation.urlIsValid = true;
      } else {
        this.formValidation.urlIsValid = false;
      }
    },
    "modelform.website"(newValue) {
      if (newValue > 10 ) {
        this.formValidation.urlIsValid = true;
      } else {
        this.formValidation.urlIsValid = false;
      }
    },
  },
  computed: {
    ...mapState({
      availableTokens: (state) => state.optionsList.all["available_tokens"],
      completeLoadingTarget: (state) => state.optionsList.completeLoadingTarget,
      readyToPrepear: (state) => state.onboarding.readyToPrepear,
      onBoarding: (state) => state.onboarding,
      target_status_id: (state) => state.onboarding.target_status_id,
      tabs: (state) => state.onboarding.tabs,
      tag_id: (state) => state.onboarding.step3.tag_id,
      loading: (state) => state.onboarding.loading,
      size: (state) => state.onboarding.size,
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      tag_2: (state) => state.optionsList.all["tag_2"],
    }),
    textQtyCharacters() {
      const qty = this.onBoarding.descriptionSell
        ? this.onBoarding.descriptionSell.length
        : 0;
      return `( ${qty} / 2000 )`;
    },
    correctNumberCharacters() {
      const qty = this.onBoarding.descriptionSell
        ? this.onBoarding.descriptionSell.length
        : 0;
      return qty > 2000 ? false : true;
    },
  },

  components: {
    IndustrySearch,
    MailsModal,
    LoadingSpinner,
    Step1Summary,
    TargetsModal,
    Step2Summary,
    TeamMembers,
    PreviewEmail,
    TargetStepCampaingPreview,
    Modal,
    StatusComment,
    CreditCardForm,
    VideoToolToy,
    CustomMsg,
    Tabs,
    Tooltip,
    "vue-form-generator": VueFormGenerator.component,
  },
  props: {
    simplify: Boolean,
    addOrder: Boolean,
    targetId: false,
    typeForm: false,
  },
  beforeMount() {
    this.verificationOrder = this.onBoarding.validationTarget;
    this.verificationOrder.target_id = this.targetId;
  },
  mounted() {
    if(this.onBoarding.lang == null || this.onBoarding.lang == ""){
       this.setLanguageId(this.currentUser.language_id)
      }

    this.getSales();
  },
  created() {
    if (this.typeForm == "onboarding") {
      this.setTypeForm("onboarding");
    }
    if (!this.completeLoadingTarget) {
      this.$store.dispatch("optionsList/getAllTargetParams");
    }
    this.updateCompanyName(this.currentUser.client_name);
    this.setEmailDataToken();
    let defaultDate = this.formatDate();
    if (
      this.onBoarding.step3.launchDate == "" ||
      this.onBoarding.step3.launchDate == undefined
    ) {
      this.updateLaunchDate(defaultDate);
      this.modelform.launchDate = defaultDate;
    }

    this.modelform.website = this.onBoarding.website;
    this.validateForm();

    if (this.onBoarding.orderName.length == 0) {
      this.updateOrderName("My order " + this.currentUser.name);
    }
    if (!this.addOrder && this.simplify) {
      if (this.targetId) {
        this.loadTarget(this.targetId);
      }
    }

    this.changeLanguage();
  },
  methods: {
    ...mapActions("onboarding", {
      setDisabledTab : "setDisabledTab",
       setCampaingSteps: "setCampaingSteps",
      setOrderData: "setOrderData",
      setEmailDataToken: "setEmailDataToken",
      loadTarget: "loadTarget",
      copy: "copy",
      setStep: "goToStep",
      setSubStep: "goToSubStep",
      setTab: "setTab",
      updateAppointmentVolume: "updateAppointmentVolume",
      updateLaunchDate: "updateLaunchDate",
      updatePositions: "updatePositions",
      updateDepartments: "updateDepartments",
      updateCountry: "updateCountry",
      updateRegion: "updateRegion",
      updateSizes: "updateSizes",
      updatePrice: "updatePrice",
      updateAdminPrice: "updateAdminPrice",
      updatePreviewTemplate: "updatePreviewTemplate",
      updateSectorsExclude: "updateSectorsExclude",
      updateCategoryJobs: "updateCategoryJobs",
      updateSectorsInclude: "updateSectorsInclude",
      updateProductName: "updateProductName",
      updateOrderName: "updateOrderName",
      updateBenefitsOffer: "updateBenefitsOffer",
      updateOfferAttractive: "updateOfferAttractive",
      updateDescriptionSell: "updateDescriptionSell",
      updateWebsite: "updateWebsite",
      updateTargetStatusId: "updateTargetStatusId",
      setOrderId: "setOrderId",
      changeLang: "changeLangAction",
      setLanguageId: "setLanguageId",
      updateServiceDescription: "updateServiceDescription",
      addTeamMember: "addTeamMember",
      clearTeamMember: "clearTeamMember",
      updateTagId: "updateTagId",
      cleanOnboarding: "clean",
      updateOfferProspect: "updateOfferProspect",
      save: "save",
      updateCompanyName: "updateCompanyName",
      setTypeForm: "setTypeForm",
      updateSales: "updateSales",
      validateForm: "validateForm",
    }),
    isOpen(type) {
      return this.editing[type] !== undefined && this.editing[type] == true;
    },
    changeTagId(e) {
      this.updateTagId(e.target.value);
    },
     changeOfferProspect(e) {
      this.updateOfferProspect(e.target.value);
    },
    openEdit(type) {
      if (type == "website") {
        this.modelform.website = this.onBoarding.website;
      }
      this.editing[type] = true;
      this.$forceUpdate();
    },
    closeEdit(type) {
      if (type === "price") this.editingAppointPrice = false;
      this.savenow(false, false);
      this.editing[type] = false;
      this.$forceUpdate();
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    disabledEdit() {
      //1 > active or prepearing
      //2 > stop or inactive
      //3 > pending
      //4 > running
      //5 > archived

      if (this.currentUser.role_id == 1) {
        return false;
      }

      if (this.hasPermissions("adminClients")) {
        return false;
      }

      return (
        this.target_status_id == 4 ||
        this.target_status_id == 2 ||
        this.target_status_id == 1
      );
    },
    disabledEditSales() {
      //1 > active or prepearing
      //2 > stop or inactive
      //3 > pending
      //4 > running
      //5 > archived

      if (this.currentUser.role_id == 1) {
        return false;
      }

      if (this.hasPermissions("adminClients")) {
        return false;
      }

      return this.target_status_id == 4 || this.target_status_id == 1;
    },
    previewTemplate() {
      return (
        (this.onBoarding.previewTemplate == 1 &&
          this.typeForm != "onboarding") ||
        this.currentUser.role_id == 1
      );
      // return (this.onBoarding.orderId == undefined || this.onBoarding.orderId == 0 || this.onBoarding.orderId > 810)
    },
    isStatusPending() {
      //1 > active
      //2 > stop
      //3 > pending
      return (
        (this.target_status_id == 3 || this.target_status_id == 1) &&
        !this.addOrder
      );
    },
    goToSubStep(step, substep) {
      this.setStep(step);
      this.setSubStep(substep);
    },
    editStep(step) {
      if (this.typeForm == "onboarding") {
        this.goToSubStep(step, 1);
      } else {
        if (step == 1) this.showModal("mails");
        else if (step == 2) this.showModal("targets");
      }
    },
    showModal(modal) {
      this.$modal.show(modal);
      if (modal == "targets") {
        this.showTarget = false;
        this.targetkey++;
      }
    },
    refreshTarget(result) {
      this.apolloResult = result;
      this.targetkey++;
    },
    closeModal(modal) {
      if (modal == "targets") {
        this.step2sum++;
      }
      this.$modal.hide(modal);
      //}
      this.showTarget = true;
    },
    openModal(modal) {
      this.$modal.show(modal);
    },
    emptyQuestions() {
      return !this.onBoarding.step1Ready && this.previewTemplate();
    },
    validate() {
      if (!this.readyToPrepear) {
        this.$modal.show("Errors");
        return true;
      } else {
        // if (this.simplify) {
        //   this.savenow(true, true);
        // } else {
        //   this.$modal.show("start-campaings");
        // }

        this.$swal({
          type: "warning",
          title: this.$t('lang.onBoarding.start_preparing_my_campaigns_month'),
          html: this.$t('lang.onBoarding.confirm_preparing_campaign'),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t('lang.button.yes'),
        }).then((result) => {
          if (result.value) {
            if (this.previewTemplate()) {
              this.savenow(true, true);
            } else {
              this.$modal.show("videotraining");
              this.savenow(false, true);
            }
            return false
          }
        });
        return false;
      }
    },
    saveOrderClosed(){
      const { orderId, closed }= this.onBoarding;
      const data = {
        target_id: orderId,
        closed
      }
      targetsService
        .updatedOrderClosed(data)
        .then((res) => {
          if(res.status === 200){
            this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                text: this.$t("lang.label.datasavedsuccessfully"),
                showConfirmButton: false,
                timer: 2000,
              })
          }
        })
        .catch((err) => {
          this.$swal({
            type: "error",
            title: ( err.status === 401 ) ? this.$t("lang.general.permissiondenied") : this.$t("lang.label.error"),
            text: ( err.status === 401 ) ? this.$t("lang.general.permissiondenied") : this.$t("lang.label.error"),
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            if (this.typeForm == "onboarding") {
              targetsService.getAll().then((response) => {
                if (response.length > 0) {
                  this.loadTarget(response[response.length - 1].id);
                  this.goToSubStep(3, 1);
                }
              });
            }
          });
        });
    },
    savenow(changeTargetStatusToActive, redirect) {
      console.log("ejecuta");
      this.setOrderData();
      let onboarding = this.onBoarding.orderdata;

      if (
        this.hasPermissions('superAdminTargets') &&
        this.simplify &&
        this.editPrice
      ) {
        onboarding.price = this.onBoarding.step3.appointmentPrice;
      }

      if (this.simplify) {
        //onboarding.updateSales = this.onBoarding.step3.updateSales;
        if(this.targetId){
            onboarding.updateSales = this.onBoarding.step3.updateSales;
        }else{
          onboarding.salesRep = this.onBoarding.step3.updateSales;
        }

      } else {
        onboarding.salesRep = this.onBoarding.step3.teamMembers;
      }

      if(onboarding.client_id == 0){
        onboarding.client_id = this.currentUser.client_id
      }
      console.log(this.currentUser.client_id)
      if (
        this.onBoarding.modelCampaingStep.tabSelected.id == 2 &&
        this.target_status_id == 3
      ) {
        onboarding.tabSelect = this.onBoarding.modelCampaingStep.tabSelected.id;
      }
      onboarding.change_target_status_to_active = changeTargetStatusToActive;

      targetsService
        .addTarget(onboarding)
        .then((res) => {
          if (redirect) {
            if (this.isIdValid(res)) {
              // if (this.oliverEmailSequence) {
              //   this.$modal.hide("start-campaings");
              //   this.loadingEmailSequence = false;
              // }
              this.setOrderId(res);
              this.targetId = res;
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                text: this.$t("lang.label.datasavedsuccessfully"),
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                if (redirect) {
                  if (
                    this.onBoarding.typeForm == "onboarding" &&
                    changeTargetStatusToActive
                  ) {
                    window.location.reload()
                  } else {
                    if (this.currentUser.role_id != 1) {
                      this.$router.push("/orders/");
                    }else{
                      this.loadTarget(this.targetId);
                    }
                  }
                }
              });
            } else {
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                html: this.$t("lang.general.error"),
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                if (this.typeForm == "onboarding") {
                  targetsService.getAll().then((response) => {
                    if (response.length > 0) {
                      this.loadTarget(response[response.length - 1].id);
                    }
                  });
                }
              });
            }
          } else {
            if (
              this.onBoarding.targetId == 0 ||
              this.onBoarding.targetId == null
            ) {
              if (this.isIdValid(res)) {

                this.setOrderId(res);
              }
            }
          }
        })
        .catch((err) => {
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.label.error"),
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            if (this.typeForm == "onboarding") {
              targetsService.getAll().then((response) => {
                if (response.length > 0) {
                  this.loadTarget(response[response.length - 1].id);
                  this.goToSubStep(3, 1);
                }
              });
            }
          });
        });
    },

    changeStatus(status) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
      }).then((result) => {
        if (result.value) {
          let order = {
            id: this.onBoarding.orderId,
            target_status_id: status,
          };
          targetsService.updateTarget(order).then((res) => {
            if (res == order.id) {
              if (this.typeForm == "onboarding") {
                this.showModal("confirm");
              }
            } else {
              this.$swal({
                type: "error",
                title: this.$t("lang.label.error"),
                text: this.$t("lang.label.error"),
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
          if (this.simplify) {
            this.$router.push("/orders/");
          }
        }
      });
    },

    isIdValid(val) {
      if (val != null && val != undefined && val > 0 && val) {
        return true;
      } else {
        return false;
      }
    },

    fillSizes() {
      this.selected_sizes = [];
      this.select_list_sizes.forEach((item) => {
        let label = item.label.replace("+", "").split("-");
        let less = label[0];
        let greater = label[1];
        if (
          less <= this.size.keywords.less &&
          greater >= this.size.keywords.greater
        ) {
          this.selected_sizes.push(item.id);
        }
      });
      this.updateSizes(this.selected_sizes);
    },

    fillKeywordsSizes() {
      let greater = 0;
      let less = 0;
      this.selected_sizes.sort();

      this.selected_sizes.forEach((value, index) => {
        let keywords = this.select_list_sizes[value].label
          .replace("+", "")
          .split("-");
        if (!keywords[1]) {
          keywords[1] = "10000000";
        }
        if (Number(keywords[0]) < greater || greater === 0) {
          greater = Number(keywords[0]);
        }
        if (Number(keywords[1]) > less) {
          less = Number(keywords[1]);
        }
      });

      this.size.keywords.greater = greater;
      this.size.keywords.less = less;
    },

    getSales() {
      usersService.getSales(this.targetId).then((result) => {
        result.forEach((item) => {
          if (this.addOrder) {
            if (item.target_id == null) {
              if (item.warm_days != null) {
                this.salesRep.push({
                  id: item.id,
                  label:
                    item.email +
                    " (warmup: " +
                    item.warm_days +
                    this.$t("lang.label.days") +
                    ")",
                });
              } else {
                this.salesRep.push({
                  id: item.id,
                  label: item.email,
                });
              }
            } else {
              this.salesRep.push({
                id: item.id,
                label:
                  item.email +
                  " (" +
                  this.$t("lang.targets.salesunavailable") +
                  ")",
                isDisabled: true,
              });
            }
          } else {
            if (
              item.target_id == null ||
              item.target_id == this.onBoarding.orderId
            ) {
              this.salesRep.push({
                id: item.id,
                label: item.email,
              });
            } else {
              this.salesRep.push({
                id: item.id,
                label:
                  item.email +
                  " (" +
                  this.$t("lang.targets.salesunavailable") +
                  ")",
                isDisabled: true,
              });
            }
            if (item.target_id == this.onBoarding.orderId) {
              this.modelform.sales.push(item.id);
            }
          }
          this.updateSales(this.modelform.sales);

          // if(item.target_id == response.id){
          //   this.modelform.sales.push(item.id)
          // }
        });

        this.loadingSales = false;
      });
    },
    changeLanguage(save) {
      let language_id;
      language_id = 1;
      if (this.onBoarding.lang == "fr") {
        language_id = 1;
      }
      if (this.onBoarding.lang == "en") {
        language_id = 2;
      }
      if (this.onBoarding.lang == "es") {
        language_id = 3;
      }

      this.setLanguageId(language_id);
      if (save) {
        this.closeEdit("language");
      }
    },
    changeOrderName(e) {
      this.updateOrderName(e.target.value);
    },
    changeDescriptionSell(e) {
      this.updateDescriptionSell(e.target.value);
    },
    changeOfferAttractive(e) {
      this.updateOfferAttractive(e.target.value);
    },
    changeBenefitsOffer(e) {
      this.updateBenefitsOffer(e.target.value);
    },
    changeProductName(e) {
      this.updateProductName(e.target.value);
    },

    changeWebsite(e) {
      if (this.$refs.websiteForm.errors.length > 0) {
        return;
      }
      this.updateWebsite(this.modelform.website);
      this.closeEdit("website");
    },
    changeAppointmentVolume(e) {
      if(e.target.value < 10){
        this.formValidation.appointment = true
      } else {
        this.formValidation.appointment = false
      }
      this.updateAppointmentVolume(this.onBoarding.step3.appointmentVolume);
    },
    changeAppointmentPrice(e) {
      if (e.target.value != this.onBoarding.step3.appointmentPrice) {
        if (e.target.value < 0) {
          e.target.value = 149;
        }
        this.editPrice = true;
        this.updatePrice(e.target.value);
      }
    },
    changeLaunchDate() {
      this.$refs.launchDateForm.validate();
      if (this.$refs.launchDateForm.errors.length > 0) {
        return;
      }
      this.updateLaunchDate(this.modelform.launchDate);
      this.closeEdit("launchDate");
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },

    verificateOrder() {
      targetsService.verificateTarget(this.verificationOrder).then((res) => {
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.label.datasavedsuccessfully"),
          showConfirmButton: false,
          timer: 2000,
        });
      });
      this.editing["verified"] = false;
      this.$forceUpdate();
    },

    changeVerificateOrder(verificate) {
      verificate.target_id = this.targetId;
      this.verificationOrder = verificate;
    },
    trainingPass() {
      if (this.training_check && this.trainingCheck_2 && this.trainingCheck_3) {
        this.$modal.hide("videotraining");
        this.savenow(true,true);
      }
    },

    changeTab(tab) {
      this.setTab(tab);
    },

    duplicate() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
      }).then((result) => {
        if (result.value) {
          this.loadingSales = true;
          this.copy();
          this.modelform.sales = [];
          this.salesRep = [];
          this.addOrder = true;
          this.getSales();
        }
      });
    },

    formatDate() {
      return moment().add(2, "weeks").startOf("day").format("YYYY-MM-DD");
    },

    textQtyCharactersGlobal(field) {
      const qty = field
        ? field.length
        : 0;
      return `( ${qty} / 2000 )`;
    },
    correctNumberCharactersGlobal(field) {
         const qty = field
        ? field.length
        : 0;
      return qty > 2000 ? false : true;
    },



    //Guardamos los mensajes personalizados de la campagña
    saveTargetCampaignStep(data) {
      this.$modal.hide("mails");
      this.modelCampaingStep = data;
      if (
        this.currentUser.role_id == 1 &&
        this.onBoarding.modelCampaingStep.campaign_steps[0].id == undefined
      ) {

        this.$swal({
          type: "warning",
          title: this.$t("lang.label.acceptChangeCustomTemplate"),
          text: "",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.yes"),
        }).then((result) => {
          if (result.value) {
            this.modelCampaingStep = data;
            targetsService
              .addCampaignStep(this.modelCampaingStep)
              .then((res) => {
                if (res) {
                  if (res.length > 0) {
                     this.modelCampaingStep.campaign_steps = res;
                      this.setCampaingSteps(res);
                      this.setDisabledTab(2)
                    this.$swal({
                      type: "success",
                      title: this.$t("lang.label.great"),
                      text: this.$t("lang.label.datasavedsuccessfully"),
                      showConfirmButton: false,
                      timer: 2000,
                    }).then(() => {

                      this.$modal.show("mails");
                    });

                  }
                }
              });
          }
        });
      }else{

            targetsService
              .addCampaignStep(this.modelCampaingStep)
              .then((res) => {
                if (res) {
                  if (res.length > 0) {
                    this.$swal({
                      type: "success",
                      title: this.$t("lang.label.great"),
                      text: this.$t("lang.label.datasavedsuccessfully"),
                      showConfirmButton: false,
                      timer: 2000,
                    }).then(() => {
                      this.$modal.show("mails");
                    });
                    this.modelCampaingStep.campaign_steps = res;
                     this.setCampaingSteps(res);

                  }
                }
              });
      }
    },
  },
};
</script>
<style scoped>
.btn_pause {
  background-color: #ffc107;
}
.bg-paused {
  background-color: #fefcdd;
  border: 3px solid #faf879;
  color: #abaaa3;
  font-weight: 700;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
